import { connect } from "react-redux";
import {
  ADMIN,
  MANAGER,
  PERMISSIONS,
  ROLE,
  SUBROLE,
  USER,
  PERMISSIONS_OPTIONS,
  ROLES_WITH_PERMISSION
} from "MODULES/users/constants";
import { isEmpty } from "lodash";

function Authorized({ authorized, children }) {
  return authorized ? children : false;
}

export default connect((state, ownProps) => {
  const user = state.session.get(USER);
  const userRole = user.get(ROLE);
  const userSubRole = user.get(SUBROLE);
  const userPermissions = user.get(PERMISSIONS);

  const otherRoles =
    userPermissions && ownProps.roles
      ? userPermissions.toJS().filter(a => ownProps.roles.includes(a))
      : [];

  const hasRole =
    [ADMIN].concat(ownProps.roles).includes(userRole) || otherRoles.length > 0;

  const otherSubroles =
    userPermissions && ownProps.subroles
      ? userPermissions.toJS().filter(a => ownProps.subroles.includes(a))
      : [];

  const hasUserSubRole =
    ownProps.subroles &&
    (ownProps.subroles.includes(userSubRole) || otherSubroles.length > 0);

  const isManager = state.session.getIn([USER, MANAGER]);
  const hasOverriddenPermission =
    ownProps.permissions &&
    user.get(PERMISSIONS) &&
    ownProps.permissions.some(f => user.get(PERMISSIONS).includes(f));

  const roleHasPermission = Object.keys(PERMISSIONS_OPTIONS).map(f => {
    const val =
      ROLES_WITH_PERMISSION[f] && ROLES_WITH_PERMISSION[f].includes(userRole);

    return {
      permissions: {
        label: f,
        value: val
      }
    };
  });
  const setPermision = roleHasPermission.filter(
    f =>
      f.permissions.value === true &&
      (ownProps.permissions &&
        ownProps.permissions.includes(f.permissions.label))
  );

  return {
    authorized:
      hasRole ||
      hasUserSubRole ||
      (ownProps.allowManagers && isManager) ||
      (ownProps.authorizedIf && ownProps.authorizedIf(user)) ||
      hasOverriddenPermission ||
      !isEmpty(setPermision)
  };
})(Authorized);



// WEBPACK FOOTER //
// ./app/modules/shared/components/Authorized/Authorized.jsx